import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { AutocompleteCP } from '../../interfaces/autocomplete';


@Injectable({
  providedIn: 'root'
})
export class AutoCompleteService {

  private AUTO_COMPLETE_TYPES:Array<string> = ["cp","cp_correspondance"]
  private readonly HOST:string = environment.BASE_URL
  constructor(
    private httpClient: HttpClient
    ) { }

    async autocomplete(type:string, searchString:string):Promise<Observable<AutocompleteCP[]>>
    {
      if(!this.AUTO_COMPLETE_TYPES.includes(type)) return new Observable<AutocompleteCP[]>()

      const url  = `${this.HOST}/autocomplete`

      return this.httpClient.get<AutocompleteCP[]>(url,
        {
          params:
          {
            type:type,
            data:searchString
          }
        })
    }
}
